module.exports = __webpack_public_path__ + "assets/5f2ac39b009da0f6e1676741a771716f.png";